import { Entity } from '@pinup-teams/common';

export interface UserFinancialRequest {
  requestId: number;
  requestType: string;
  requestIdHash: string;
  date: Date;
  status: FinancialRequestStatus;
}

export enum FinancialRequestStatus {
  New = 'new',
  InProgress = 'inProgress',
  Rejected = 'rejected',
  Completed = 'completed',
  Canceled = 'canceled',
}

export interface FinancialCategory extends Entity {
  name: string;
  description: string;
}

export interface FinancialRequestDetailsEncryptedComments {
  requestIdHash?: string;
  data: {
    date?: Date;
    message: string;
    fromUser?: string;
    status: FinancialRequestStatus;
  };
  files?: string[];
}

export interface GetRequestIdHashRes {
  request: {
    requestIdHash: string;
  };
}

export interface CreateRequestReq {
  categoryId: string;
  requestType: string;
  requestIdHash: string;
}

export interface CreateRequestRes {
  request: UserFinancialRequest;
}

export type SaveRequestEncryptedData = FinancialRequestDetailsEncryptedComments;

export interface GetFinancialCategoriesRes {
  categories: FinancialCategory[];
}
